import * as React from 'react';
import { Redirect, Switch, withRouter } from 'react-router';
import './Apps.css';
import SecuredRoute from './components/SecuredRoute/SecuredRoute';
import Payables from './pages/Payables/Payables';
import Search from './pages/Search/Search';

class Apps extends React.Component<any, any> {
  public render() {
    return (
      <Switch>
        <SecuredRoute path="/search" component={Search} />
        <SecuredRoute path="/payables" component={Payables} />

        <Redirect
          to={{
            pathname: '/search'
          }}
        />
      </Switch>
    );
  }
}

export default withRouter(Apps);
